import React, { useEffect, useState, useCallback } from 'react'


/**
 * Helps to watch on a field, returns actual field state
 *
 * @param {Object} field
 * @returns {Object}
 */
const useFormField = (field) => {
  const [ state, setState ] = useState(field.getState())

  useEffect(() => {
    const handleUpdate = () => {
      setState(field.getState())
    }

    field.on('start validate', handleUpdate)
    field.on('validate', handleUpdate)
    field.on('change', handleUpdate)
    field.on('unset', handleUpdate)

    return () => {
      field.off('start validate', handleUpdate)
      field.off('validate', handleUpdate)
      field.off('change', handleUpdate)
      field.off('unset', handleUpdate)
    }
  }, [ field ])

  const set = useCallback((newValue) => {
    field.set(newValue)
  }, [ field ])

  return { ...state, set }
}


export default useFormField
